import {
  EMPLOYEE_LOG_REPORT,
  EMPLOYEE_LOG_REPORT_SUCCESS,
  EMPLOYEE_LOG_REPORT_ERROR,
  GET_EMPLOYEE_LOG_LIVE,
  GET_EMPLOYEE_LOG_LIVE_SUCCESS,
  GET_EMPLOYEE_LOG_LIVE_ERROR,
  GET_VISITOR_LOG_LIVE,
  GET_VISITOR_LOG_LIVE_SUCCESS,
  GET_VISITOR_LOG_LIVE_ERROR,
  ADD_EMPLOYEE_LOG_LIVE,
  PEOPLE_COUNT_LOG_REPORT,
  PEOPLE_COUNT_LOG_REPORT_SUCCESS,
  PEOPLE_TRACK_LOG_REPORT_ERROR,
  PEOPLE_TRACK_LOG_REPORT,
  PEOPLE_TRACK_LOG_REPORT_SUCCESS,
  PEOPLE_COUNT_LOG_REPORT_ERROR,
  PEOPLE_COUNT_DASH,
  PEOPLE_COUNT_DASH_SUCCESS,
  PEOPLE_COUNT_DASH_ERROR,
  PEOPLE_COUNT_DASH_ADD,
  VEHICLE_COUNT_DASH,
  VEHICLE_COUNT_DASH_SUCCESS,
  VEHICLE_COUNT_DASH_ERROR,
  VEHICLE_COUNT_LOG_REPORT,
  VEHICLE_COUNT_LOG_REPORT_SUCCESS,
  VEHICLE_COUNT_LOG_REPORT_ERROR,
  VEHICLE_COUNT_DASH_ADD,
  PEOPLE_OCCUPANCY_LOG_REPORT,
  PEOPLE_OCCUPANCY_LOG_REPORT_SUCCESS,
  PEOPLE_OCCUPANCY_LOG_REPORT_ERROR,
  AGE_GENDER_LOG_REPORT,
  AGE_GENDER_LOG_REPORT_SUCCESS,
  AGE_GENDER_LOG_REPORT_ERROR,
  ADD_ANPR_LOG_LIVE,
  ANPR_REPORT,
  ANPR_REPORT_SUCCESS,
  ANPR_REPORT_ERROR,
  ADD_ANPR_REPORT,
  ADD_ANPR_REPORT_SUCCESS,
  ADD_ANPR_REPORT_ERROR,
  UPDATE_ANPR_REPORT,
  UPDATE_ANPR_REPORT_SUCCESS,
  UPDATE_ANPR_REPORT_ERROR,
  ANPR_LIVE_REPORT,
  ANPR_LIVE_REPORT_SUCCESS,
  ANPR_LIVE_REPORT_ERROR,
  ANPR_SEARCH_REPORT,
  ANPR_SEARCH_REPORT_SUCCESS,
  ANPR_SEARCH_REPORT_ERROR,
  VEHICLE_LIVE_PARKING,
  VEHICLE_LIVE_PARKING_SUCCESS,
  VEHICLE_LIVE_PARKING_ERROR,
  PARKING_LOG_REPORT,
  PARKING_LOG_REPORT_SUCCESS,
  PARKING_LOG_REPORT_ERROR,
  LIGHTING_LOG_REPORT,
  LIGHTING_LOG_REPORT_SUCCESS,
  LIGHTING_LOG_REPORT_ERROR,
  PEOPLE_OCCUPANCY_DASH,
  PEOPLE_OCCUPANCY_DASH_SUCCESS,
  PEOPLE_OCCUPANCY_DASH_ERROR,
  AGE_GENDER_DASH,
  AGE_GENDER_DASH_SUCCESS,
  AGE_GENDER_DASH_ERROR,
  ANPR_DASH,
  ANPR_DASH_SUCCESS,
  ANPR_DASH_ERROR,
  PARKING_DASH,
  PARKING_DASH_SUCCESS,
  PARKING_DASH_ERROR,
  LIGHTING_DASH,
  LIGHTING_DASH_SUCCESS,
  LIGHTING_DASH_ERROR,
  COMPLIANCE_ALERT_ADD,
  COMPLIANCE_ALERT_REPORT,
  COMPLIANCE_ALERT_REPORT_SUCCESS,
  COMPLIANCE_ALERT_REPORT_ERROR,
  COMPLIANCE_ALERT_LIVE_RECENT,
  COMPLIANCE_ALERT_LIVE_RECENT_SUCCESS,
  COMPLIANCE_ALERT_LIVE_RECENT_ERROR,
  COMPLIANCE_ALERT_DASH,
  COMPLIANCE_ALERT_DASH_SUCCESS,
  COMPLIANCE_ALERT_DASH_ERROR,
  ADD_COMPLIANCE_LOG_CHECK,
  COMPLIANCE_LOG_CHECK_RECENT,
  COMPLIANCE_LOG_CHECK_RECENT_ERROR,
  COMPLIANCE_LOG_CHECK_RECENT_SUCCESS,
  FACILITY_ALERT_REPORT,
  FACILITY_ALERT_REPORT_SUCCESS,
  FACILITY_ALERT_REPORT_ERROR,
  COMPLIANCE_MASK_APPROVE,
  COMPLIANCE_MASK_APPROVE_SUCCESS,
  COMPLIANCE_MASK_APPROVE_ERROR,
  COMPLIANCE_ALERT_UPDATE,
  COMPLIANCE_ALERT_UPDATE_SUCCESS,
  COMPLIANCE_ALERT_UPDATE_ERROR,
} from "./actions";

import {
  countWise,
  countWiseAtrribute,
} from "../../components/charting/ChartProcessor";

import { reject } from "lodash";

const INIT_STATE = {
  employee_log_report: [],
  employee_logs_live: [],
  visitor_logs_live: [],
  employee_logs_live_summary: { labels: [], values: [] },
  people_count_log_report: [],
  people_track_log_report: [],
  people_occupancy_log_report: [],
  age_gender_log_report: [],
  anpr_log_report: [],
  anpr_logs_live: [],
  anpr_search_report: [],
  vehile_live_parking: [],
  anpr_logs_report: [],
  parking_log_report: [],
  lighting_log_report: [],
  complaince_log_check: [],
  people_count_dash: [],
  vehicle_count_dash: [],
  vehicle_count_log_report: [],
  people_occupancy_dash: [],
  age_gender_dash: [],
  anpr_dash: [],
  parking_dash: [],
  lighting_dash: [],
  compliance_alert_log_live: [],
  compliance_alert_log_report: [],
  compliance_log_dash: [],
  compliance_alert_summary: {},
  faclity_alert_log_report: [],

  error: "",
  loading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case EMPLOYEE_LOG_REPORT:
      return {
        ...state,
        employee_log_report: [],
        loading: true,
        error: "",
      };
    case EMPLOYEE_LOG_REPORT_SUCCESS:
      return {
        ...state,
        employee_log_report: action.payload,
        loading: false,
        error: "",
      };
    case EMPLOYEE_LOG_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_EMPLOYEE_LOG_LIVE:
      return {
        ...state,
        employee_logs_live: [],
        loading: true,
        error: "",
      };

    case GET_EMPLOYEE_LOG_LIVE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case GET_EMPLOYEE_LOG_LIVE_SUCCESS:
      return {
        ...state,
        loading: false,
        employee_logs_live: action.payload.reverse(),
        employee_logs_live_summary: countWiseAtrribute(
          action.payload,
          "sector",
          "direction",
          ["IN", "OUT", "INOUT"]
        ),
      };
      case GET_VISITOR_LOG_LIVE:
        return {
          ...state,
          visitor_logs_live: [],
          loading: true,
          error: "",
        };
  
      case GET_VISITOR_LOG_LIVE_ERROR:
        return {
          ...state,
          loading: false,
          error: action.payload.message,
        };
      case GET_VISITOR_LOG_LIVE_SUCCESS:
        return {
          ...state,
          loading: false,
          visitor_logs_live: action.payload.reverse(),
          visitor_logs_live_summary: countWiseAtrribute(
            action.payload,
            "sector",
            "direction",
            ["IN", "OUT", "INOUT"]
          ),
        };
  
    case ADD_EMPLOYEE_LOG_LIVE:
      return {
        ...state,
        loading: false,
        employee_logs_live: [action.payload].concat(state.employee_logs_live),
      };

    case ADD_COMPLIANCE_LOG_CHECK:
      return {
        ...state,
        loading: false,
        complaince_log_check: [action.payload].concat(
          state.complaince_log_check
        ),
      };

    case COMPLIANCE_LOG_CHECK_RECENT:
      return {
        ...state,
        complaince_log_check: [],
        loading: true,
        error: "",
      };
    case COMPLIANCE_LOG_CHECK_RECENT_SUCCESS:
      return {
        ...state,
        complaince_log_check: action.payload.reverse(),
        loading: false,
        error: "",
      };
    case COMPLIANCE_LOG_CHECK_RECENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case COMPLIANCE_MASK_APPROVE:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case COMPLIANCE_MASK_APPROVE_SUCCESS:
      console.log("reached reducer");
      return {
        ...state,
        loading: false,
        complaince_log_check: reject(
          state.complaince_log_check,
          action.payload
        ),
      };
    case COMPLIANCE_MASK_APPROVE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };

    case COMPLIANCE_ALERT_UPDATE:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case COMPLIANCE_ALERT_UPDATE_SUCCESS:
      let updatedData = [...state.compliance_alert_log_live];
      updatedData[action.payload.index]['description'] = action.payload.description
      return {
        ...state,
        loading: false,
        compliance_alert_log_live: [...updatedData]
      };
    case COMPLIANCE_ALERT_UPDATE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };


    case PEOPLE_COUNT_LOG_REPORT:
      return {
        ...state,
        people_count_log_report: [],
        loading: true,
        error: "",
      };
    case PEOPLE_COUNT_LOG_REPORT_SUCCESS:
      return {
        ...state,
        people_count_log_report: action.payload,
        loading: false,
        error: "",
      };
    case PEOPLE_COUNT_LOG_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PEOPLE_TRACK_LOG_REPORT:
      return {
        ...state,
        people_track_log_report: [],
        loading: true,
        error: "",
      };
    case PEOPLE_TRACK_LOG_REPORT_SUCCESS:
      return {
        ...state,
        people_track_log_report: action.payload,
        loading: false,
        error: "",
      };
    case PEOPLE_TRACK_LOG_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case VEHICLE_COUNT_LOG_REPORT:
      return {
        ...state,
        vehicle_count_log_report: [],
        loading: true,
        error: "",
      };
    case VEHICLE_COUNT_LOG_REPORT_SUCCESS:
      return {
        ...state,
        vehicle_count_log_report: action.payload,
        loading: false,
        error: "",
      };
    case VEHICLE_COUNT_LOG_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PEOPLE_COUNT_DASH:
      return {
        ...state,
        people_count_dash: [],
        loading: true,
        error: "",
      };
    case PEOPLE_COUNT_DASH_SUCCESS:
      return {
        ...state,
        people_count_dash: action.payload,
        loading: false,
        error: "",
      };
    case PEOPLE_COUNT_DASH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PEOPLE_COUNT_DASH_ADD:
      return {
        ...state,
        people_count_dash: [action.payload].concat(state.people_count_dash),
      };

    case VEHICLE_COUNT_DASH:
      return {
        ...state,
        vehicle_count_dash: [],
        loading: true,
        error: "",
      };
    case VEHICLE_COUNT_DASH_SUCCESS:
      return {
        ...state,
        vehicle_count_dash: action.payload,
        loading: false,
        error: "",
      };
    case VEHICLE_COUNT_DASH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case VEHICLE_COUNT_DASH_ADD:
      return {
        ...state,
        vehicle_count_dash: [action.payload].concat(state.vehicle_count_dash),
      };
    case PEOPLE_OCCUPANCY_LOG_REPORT:
      return {
        ...state,
        people_occupancy_log_report: [],
        loading: true,
        error: "",
      };
    case PEOPLE_OCCUPANCY_LOG_REPORT_SUCCESS:
      return {
        ...state,
        people_occupancy_log_report: action.payload,
        loading: false,
        error: "",
      };
    case PEOPLE_OCCUPANCY_LOG_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case AGE_GENDER_LOG_REPORT:
      return {
        ...state,
        age_gender_log_report: [],
        loading: true,
        error: "",
      };
    case AGE_GENDER_LOG_REPORT_SUCCESS:
      return {
        ...state,
        age_gender_log_report: action.payload,
        loading: false,
        error: "",
      };
    case AGE_GENDER_LOG_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_ANPR_LOG_LIVE:
      return {
        ...state,
        loading: false,
        anpr_logs_live: [action.payload].concat(
          state.anpr_logs_live
        ),
      };

    case ANPR_REPORT:
      return {
        ...state,
        anpr_log_report: [],
        loading: true,
        error: "",
      };
    case ANPR_REPORT_SUCCESS:
      return {
        ...state,
        anpr_log_report: action.payload,
        loading: false,
        error: "",
      };
    case ANPR_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_ANPR_REPORT:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_ANPR_REPORT_SUCCESS:
      return {
        ...state,
        anpr_logs_live: [...state.anpr_logs_live, action.payload],
        loading: false,
        error: "",
      };
    case ADD_ANPR_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ANPR_REPORT:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_ANPR_REPORT_SUCCESS:
      let reportsData = [...state.anpr_logs_live];
      reportsData[action.payload.index]['actual_number_plate'] = action.payload.data.actual_number_plate
      return {
        ...state,
        anpr_logs_live: [...reportsData],
        loading: false,
        error: "",
      };
    case UPDATE_ANPR_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ANPR_LIVE_REPORT:
      return {
        ...state,
        anpr_logs_live: [],
        loading: true,
        error: "",
      };
    case ANPR_LIVE_REPORT_SUCCESS:
      return {
        ...state,
        anpr_logs_live: action.payload,
        anpr_logs_report: action.payload,
        loading: false,
        error: "",
      };
    case ANPR_LIVE_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case VEHICLE_LIVE_PARKING:
      return {
        ...state,
        vehile_live_parking: [],
        loading: true,
        error: "",
      };
    case VEHICLE_LIVE_PARKING_SUCCESS:

      let allLogs = {};
      action.payload.forEach((log) => {
        let logData = {};
        logData[log.zone] = log
        allLogs = { ...allLogs, ...logData }
      });

      return {
        ...state,
        vehile_live_parking: allLogs,
        loading: false,
        error: "",
      };
    case VEHICLE_LIVE_PARKING_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ANPR_SEARCH_REPORT:
      return {
        ...state,
        anpr_search_report: [],
        loading: true,
        error: "",
      };
    case ANPR_SEARCH_REPORT_SUCCESS:

      return {
        ...state,
        anpr_search_report: action.payload,
        loading: false,
        error: "",
      };
    case ANPR_SEARCH_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    case PARKING_LOG_REPORT:
      return {
        ...state,
        parking_log_report: [],
        loading: true,
        error: "",
      };
    case PARKING_LOG_REPORT_SUCCESS:
      return {
        ...state,
        parking_log_report: action.payload,
        loading: false,
        error: "",
      };
    case PARKING_LOG_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PEOPLE_OCCUPANCY_DASH:
      return {
        ...state,
        people_occupancy_dash: [],
        loading: true,
        error: "",
      };
    case PEOPLE_OCCUPANCY_DASH_SUCCESS:
      return {
        ...state,
        people_occupancy_dash: action.payload,
        loading: false,
        error: "",
      };
    case PEOPLE_OCCUPANCY_DASH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case AGE_GENDER_DASH:
      return {
        ...state,
        age_gender_dash: [],
        loading: true,
        error: "",
      };
    case AGE_GENDER_DASH_SUCCESS:
      return {
        ...state,
        age_gender_dash: action.payload,
        loading: false,
        error: "",
      };
    case AGE_GENDER_DASH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ANPR_DASH:
      return {
        ...state,
        anpr_dash: [],
        loading: true,
        error: "",
      };
    case ANPR_DASH_SUCCESS:
      return {
        ...state,
        anpr_dash: action.payload,
        loading: false,
        error: "",
      };
    case ANPR_DASH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PARKING_DASH:
      return {
        ...state,
        parking_dash: [],
        loading: true,
        error: "",
      };
    case PARKING_DASH_SUCCESS:
      return {
        ...state,
        parking_dash: action.payload,
        loading: false,
        error: "",
      };
    case PARKING_DASH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LIGHTING_DASH:
      return {
        ...state,
        lighting_dash: [],
        loading: true,
        error: "",
      };
    case LIGHTING_DASH_SUCCESS:
      return {
        ...state,
        lighting_dash: action.payload,
        loading: false,
        error: "",
      };
    case LIGHTING_DASH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case COMPLIANCE_ALERT_ADD:
      return {
        ...state,
        loading: false,
        compliance_alert_log_live: [action.payload].concat(
          state.compliance_alert_log_live
        ),
      };

    case COMPLIANCE_ALERT_LIVE_RECENT:
      return {
        ...state,
        compliance_alert_log_live: [],
        loading: true,
        error: "",
      };
    case COMPLIANCE_ALERT_LIVE_RECENT_SUCCESS:
      return {
        ...state,
        compliance_alert_log_live: action.payload.reverse(),
        loading: false,
        error: "",
      };
    case COMPLIANCE_ALERT_LIVE_RECENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case COMPLIANCE_ALERT_REPORT:
      return {
        ...state,
        compliance_alert_log_report: [],
        loading: true,
        error: "",
      };
    case COMPLIANCE_ALERT_REPORT_SUCCESS:
      return {
        ...state,
        compliance_alert_log_report: action.payload,
        loading: false,
        error: "",
      };
    case COMPLIANCE_ALERT_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case COMPLIANCE_ALERT_DASH:
      return {
        ...state,
        compliance_log_dash: [],
        loading: true,
        error: "",
      };
    case COMPLIANCE_ALERT_DASH_SUCCESS:
      return {
        ...state,
        compliance_log_dash: action.payload,
        compliance_alert_summary: countWise(action.payload, "type", ["count"]),
        loading: false,
        error: "",
      };
    case COMPLIANCE_ALERT_DASH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FACILITY_ALERT_REPORT:
      return {
        ...state,
        faclity_alert_log_report: [],
        loading: true,
        error: "",
      };
    case FACILITY_ALERT_REPORT_SUCCESS:
      return {
        ...state,
        faclity_alert_log_report: action.payload,
        loading: false,
        error: "",
      };
    case FACILITY_ALERT_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LIGHTING_LOG_REPORT:
      return {
        ...state,
        lighting_log_report: [],
        loading: true,
        error: "",
      };
    case LIGHTING_LOG_REPORT_SUCCESS:
      return {
        ...state,
        lighting_log_report: action.payload,
        loading: false,
        error: "",
      };
    case LIGHTING_LOG_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
